module.exports = __webpack_public_path__ + "img/9.95a148c3.png";